import { parseISO } from 'date-fns';
import dateIsAfterDate from './dateIsAfterDate';

export const multipleEmailsValidator = (rule, value, callback) => {
  const regex = /^([\w-.]+@([\w-]+\.)+[\w-]{2,})?$/;

  if (value === null || value === undefined) {
    return callback();
  }

  const inputStr = Array.isArray(value) ? value.join(';') : value;
  const result = inputStr.replace(/\s/g, '').split(/,|;/);

  for (let i = 0; i < result.length; i += 1) {
    if (!regex.test(result[i])) {
      callback(new Error('multiple_email_format'));
    }
  }
  return callback();
};

export const dateIsAfterDateValidator = (rule, value, state, callback) => {
  if (dateIsAfterDate(value, state.issued_on)) {
    callback();
  } else {
    callback(new Error('tax_point_on_wrong_date'));
  }
};

export const expenseDateValidator = (rule, value, state, callback) => {
  const issuedOn = typeof state.issuedOn === 'string' ? parseISO(state.issuedOn) : state.issuedOn;
  const dueOn = typeof value === 'string' ? parseISO(value) : value;

  if (dateIsAfterDate(issuedOn, dueOn)) {
    callback();
  } else {
    callback(new Error('due_on_is_before_issued_on_date'));
  }
};

export const dateInFutureValidator = (rule, value, state, callback) => {
  const today = new Date();
  const newValue = typeof value === 'string' ? parseISO(value) : value;

  if (dateIsAfterDate(today, newValue)) {
    callback();
  } else {
    callback(new Error('date_in_future'));
  }
};

export const validatePass = (rule, value, form, field, callback) => {
  if (value === '') {
    callback(new Error('password.password_required'));
  } else {
    if (form.passwordForm[field] !== '') {
      form.$refs.passwordForm.validateField(field);
    }
    callback();
  }
};
export const validatePassConfirmation = (rule, value, form, field, callback) => {
  if (value === '') {
    callback(new Error('password.password_confirmation_required'));
  } else if (value !== form.passwordForm[field]) {
    callback(new Error('password.passwords_not_match'));
  } else {
    callback();
  }
};
